import React from 'react';

const Compliance = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Compliance</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Regulatory alignment</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Saudi PDPL</strong> – data residency and consent rules.</li>
                <li><strong>UAE DPL</strong> – cross-border transfer compliance.</li>
                <li><strong>Qatar/Bahrain frameworks</strong> – applied as required.</li>
                <li><strong>GDPR/UK GDPR</strong> – EU/UK clients.</li>
                <li><strong>PIPEDA</strong> – Canadian clients.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Certifications</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>ISO 27001 certification in roadmap.</li>
                <li>SOC 2 Type II audit planned.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Testing & Assurance</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Annual penetration tests.</li>
                <li>Regular vendor risk reviews.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Data residency</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Hosting options in Saudi Arabia and UAE.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact</h2>
              <p className="text-gray-700 leading-relaxed">
                Compliance inquiries: hello@civioniks.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Compliance;
